export const MAP_CONFIG = Object.freeze({
  MAXZOOM_AGGS: 11,
  START_ZOOM: 4.5,
  START_LAT: 46.7,
  START_LNG: 3.06,
})

/* eslint-disable-next-line no-undef */
export const BACKEND_URL = appConfig?.BACKEND_URL
/* eslint-disable-next-line no-undef */
export const POOPET_URL = appConfig?.POOPET_URL

export const PAGE_TYPE = Object.freeze({
  MAIN_VIEW: 'main_view',
  DETAILS: 'details',
  HOME: 'home',
})

export const TYPE_VIEW_QUERY = Object.freeze({
  LOGEMENT_VIEW: 'logementView',
  DETAIL_VIEW: 'detailView',
  DIAGNOSTIC_VIEW: 'diagnosticView',
})
